(function ($) {

  if ($(".hero-slider .hero-slide").length > 1) {
    $(".hero-slider__slides").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      appendDots: $(".hero-slider__dots"),
      arrows: false,
      autoplay: true,
      autoplaySpeed: 8000
    });
  }

})(jQuery);